import { useMemo } from "react";
import { Marker, Popup } from "react-leaflet";

import { usePois } from "src/hooks";
import { CalculationResult, Selection } from "src/types";
import { wktPointToLatlng } from "src/utils/geometry.utils";
import { getLeafletMarkerIcon } from "src/utils/marker.utils";
import { getScenarios, getSubstances } from "src/utils/case-result.utils";
import { PoiResult } from "../PoiResult";

interface Props {
  caseId: string | number;
  active: boolean;
  selection: Selection;
  calculationResults: CalculationResult[];
}
export function CaseResultPoisOnMap(props: Props) {
  const { selection, calculationResults } = props;
  const { data: pois } = usePois(props.caseId);

  /**
   * Memo
   */
  const scenarios = useMemo(() => {
    if (!calculationResults) return [];
    return getScenarios(calculationResults);
  }, [calculationResults]);

  const substances = useMemo(() => {
    if (!calculationResults) return [];
    return getSubstances(calculationResults, selection);
  }, [calculationResults, selection]);

  // render the component
  return render();

  function render() {
    if (!pois) return null;
    if (!props.active) return null;

    return (
      <>
        {pois.map((poi) => {
          const { lat, lng } = wktPointToLatlng(poi.point_frontendSrid);
          return (
            <Marker key={poi.id} position={[lat, lng]} icon={getLeafletMarkerIcon("default")}>
              <Popup minWidth={400} maxWidth={800}>
                <PoiResult poi={poi} scenarios={scenarios} substances={substances} />
              </Popup>
            </Marker>
          );
        })}
      </>
    );
  }
}
